// Login page component for Soft Tag Manager
import image1 from '@/assets/image_2.png';
import login2 from '@/assets/login_2.svg';
import logo from '@/assets/logo.svg';
import { OptimizedImage } from '@/components/OptmizedImage';
import { config } from '@/utils/config';
import {
  Button,
  Select,
  Headline,
  Label,
  Subtitle,
  Title,
} from '@yaradigitallabs/ahua-react';

// Props for Login component
// singleSignOnClick: callback for SSO login button
// singleSignOn: flag for SSO state (not used in this file)
type LoginProps = {
  singleSignOnClick: (event: React.MouseEvent) => void;
  singleSignOn: boolean;
};

// Login component renders the login page UI
export const Login = ({ singleSignOnClick }: LoginProps) => {
  const environment =
    config.environment === 'production' ? '' : config.environment;
  return (
    <div className="w-full h-screen flex">
      {/* Left panel: branding, language select, login info, SSO button, footer */}
      <div className="w-[38%] h-screen flex flex-col justify-between">
        <div className="flex flex-row justify-between items-center p-12">
          <div className="flex flex-row gap-3">
            {/* App headline and logo */}
            <Headline>
              <span className="text-[28px] font-max-bold text-[#102D6A] font-medium">
                {`e.flow ${environment}`.trim()}
              </span>
            </Headline>
          </div>
          {/* Language select dropdown */}
          <Select
            cover="fill"
            value="ENG"
            css={{ width: '180px' }}
            className="font-noto-sans"
            size="xs"
            items={[{ value: 'ENG', text: 'English' }]}
          />
        </div>
        <div className="py-16 px-12">
          {/* Login illustration and info */}
          <img src={login2} alt="Login illustration" />
          <div className="mt-16">
            <Title
              css={{ color: '#102D6A' }}
              className="text-[#102D6A] font-bold font-max-bold text-[24px]"
              size="xl"
            >
              The go-to platform for Yara production
            </Title>
            <Subtitle css={{ color: '#00205C' }} className="mt-3" size="s">
              Get access to advanced tools and valuable data that will
              accelerate Operational Excellence across Yara&apos;s production
              sites.
            </Subtitle>
          </div>
          <div className="mt-16">
            {/* SSO login button */}
            <Button
              css={{ width: '100%' }}
              className="font-noto-sans"
              size="n"
              onClick={event => singleSignOnClick(event)}
            >
              Log in with SSO
            </Button>
          </div>
        </div>
        <div className="p-12 flex flex-row justify-between items-center">
          <div>
            {/* Yara logo and tagline */}
            <img src={logo} alt="Yara Logo" />
            <Label className="mt-2 text-xs" size="xs">
              Knowledge grows
            </Label>
          </div>
          {/* Privacy notice button */}
          <Button variant="ghost" size="n" iconLeading={'Privacy'}>
            Privacy Notice
          </Button>
        </div>
      </div>
      {/* Right panel: background image */}
      <div className="w-[62%] h-full flex justify-center items-center">
        <OptimizedImage
          src={image1}
          alt="Login illustration"
          className="w-full h-full"
          placeholder="bg-gradient-to-br from-blue-50 to-indigo-100"
          priority={true}
        />
      </div>
    </div>
  );
};
